module.exports = __webpack_public_path__ + "img/linkedin.a669af48.svg";